import { unitOptionsSchema } from '@chronosphereio/viz-framework-core';
import { z } from 'zod/v4';
import { absoluteTimeRangeSchema, queryMetadataSchema } from './utils';

/**
 * Zod schemas for TimeSeriesDataResponse.
 */

export const labelsSchema = z.record(z.string(), z.string());
const seriesConfigSchema = z.object({
  color: z.string().optional(),
  compareTo: z.number().nullable().optional(),
  unit: unitOptionsSchema.optional(),
  meta: z
    .object({
      metricsDdxQuery: z.string().optional(),
    })
    .catchall(z.unknown())
    .optional(),
});

export const timeSeriesValueTupleSchema = z.tuple([z.number(), z.union([z.number(), z.null()])]);

const timeSeriesSchema = z.object({
  name: z.string(),
  values: z.array(timeSeriesValueTupleSchema),
  formattedName: z.string().optional(),
  labels: labelsSchema.optional(),
  config: seriesConfigSchema.optional(),
});

export const timeSeriesDataSchema = z.object({
  timeRange: absoluteTimeRangeSchema.optional(),
  stepMs: z.number().optional(),
  series: z.array(timeSeriesSchema),
  metadata: queryMetadataSchema.optional(),
});

export const timeSeriesDataResponseSchema = z.object({
  type: z.literal('TimeSeries'),
  data: timeSeriesDataSchema,
});

export type TimeSeriesDataResponseSchema = z.infer<typeof timeSeriesDataResponseSchema>;
